import { apiSalesWeb } from '@shared/config';
import { IPlan } from '@shared/types';

export type IPlanPayload = IPlan[];

export async function getAllPlans() {
  return apiSalesWeb.get<IPlanPayload>('/plan', {
    // params: {
    //   page: 1,
    //   limit: 25,
    // },
  });
}
